module.exports = __webpack_public_path__ + "static/media/sunrise.852463e0.png";